import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';


const TruncateText = ({ children, maxLines, ellipsis }) => {

  const containerRef = useRef(null);
  const [truncatedText, setTruncatedText] = useState('');
  const [isTruncated, setIsTruncated] = useState(false);
  const [resizing, setResizing] = useState(true);
  const [truncating, setTruncating] = useState(false);


  useEffect(() => {
    handleTruncate();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    resizing && handleTruncate();
  }, [resizing]);


  useEffect(() => {
    truncating && truncateText();
  }, [truncating]);


  const handleResize = () =>
    setResizing(true);


  const handleTruncate = () => {
    const container = containerRef.current;

    if (!container) return;

    setTruncatedText(children);
    setTruncating(true);
  };


  const truncateText = () => {
    const container = containerRef.current;
    const textWrapper = container.firstChild;

    const originalText = children;
    const lineHeight = calculateLineHeight(container);
    const maxHeight = maxLines * lineHeight;
    let truncated = originalText;

    if (container.scrollHeight > maxHeight) {

      while (container.scrollHeight > maxHeight && truncated.length > 0) {
        truncated = truncated.slice(0, -1);
        textWrapper.textContent = truncated;
      }

      // truncated = truncated.slice(0, -5);  // As we add ellipsis '...' at the end we need to slice more symbols before update
      textWrapper.textContent = truncated.trimEnd();

      setTruncatedText(truncated.trimEnd());
      setIsTruncated(true);
    } else {
      setIsTruncated(false);
    }

    setResizing(false);
    setTruncating(false);
  };


  const calculateLineHeight = (element) => {
    const computedStyle = window.getComputedStyle(element);
    return parseFloat(computedStyle.lineHeight);
  };


  return (
    <div
      className="truncated-text" ref={containerRef}
      style={{
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: maxLines,
      }}
    >
      <span>
        { truncatedText || children }
      </span>
      <span className={`truncated-text__ellipsis ${truncating && !isTruncated ? 'hidden' : ''}`}>
        { (isTruncated || truncating) && ellipsis ? ellipsis : null }
      </span>
    </div>
  );
};


TruncateText.propTypes = {
  children: PropTypes.string.isRequired,
  maxLines: PropTypes.number,
  ellipsis: PropTypes.node,
};

TruncateText.defaultProps = {
  maxLines: 1,
  ellipsis: '...',
};


export default TruncateText;
